"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_MODIFICATOR_TYPE = void 0;
exports.STORE_MODIFICATOR_TYPE = {
    PRODUCT_TYPE: 'PRODUCT_TYPE'
};
//# sourceMappingURL=storeCostModificatorType.js.map